export const getCompteTiersState = ({ compteTiers }) => compteTiers

export const getCompteTiersListIsLoading = (state) =>
  getCompteTiersState(state).isLoadingCompteTiersList
export const getCompteTiers = (state) => getCompteTiersState(state).compteTiers
export const getCompteTiersCount = (state) =>
  getCompteTiersState(state).compteTiersCount
export const getErrorMessage = (state) => getCompteTiersState(state).errorMessage
export const getIsErrorFetch = (state) => getCompteTiersState(state).isErrorFetch

export const getIsSuccessRefresh = (state) =>
  getCompteTiersState(state).isSuccessRefresh

export const getSuccess = (state) => getCompteTiersState(state).success

export const getisLoadingCompteTiersAction = (state) =>
  getCompteTiersState(state).isLoadingCompteTiersAction
